var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationEyeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6823 15.1739C23.8868 15.4005 24 15.6949 24 16.0001C24 16.3053 23.8868 16.5997 23.6823 16.8263C22.3875 18.2197 19.4404 20.9325 16 20.9325C12.5596 20.9325 9.61247 18.2197 8.3177 16.8263C8.1132 16.5997 8 16.3053 8 16.0001C8 15.6949 8.1132 15.4005 8.3177 15.1739C9.61247 13.7805 12.5596 11.0676 16 11.0676C19.4404 11.0676 22.3875 13.7805 23.6823 15.1739Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 18.4664C17.3622 18.4664 18.4664 17.3622 18.4664 16.0002C18.4664 14.6381 17.3622 13.5339 16.0002 13.5339C14.6381 13.5339 13.5339 14.6381 13.5339 16.0002C13.5339 17.3622 14.6381 18.4664 16.0002 18.4664Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationEyeicon);
export default __webpack_public_path__ + "static/media/informationEyeicon.fe4a584bd9845d6c99e839ae0b757a25.svg";
export { ForwardRef as ReactComponent };